import { useEffect, useState } from "react";
import { OPENING_HOURS } from "@/data/site";

const toMin = (hhmm) => { const [h, m] = hhmm.split(":").map(Number); return h * 60 + m; };

const getStatus = () => {
  const parts = new Intl.DateTimeFormat("tr-TR", { timeZone: OPENING_HOURS.timeZone, hour: "2-digit", minute: "2-digit", weekday: "short", hour12: false }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const now = Number(get("hour")) * 60 + Number(get("minute"));
  const dayIdx = ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"].indexOf(get("weekday"));
  const today = OPENING_HOURS.week.find((d) => d.day === dayIdx);
  const closedToday = !today || today.closed || !today.open;
  const open = !closedToday && now >= toMin(today.open) && now < toMin(today.close);
  return { open, now, today, closedToday, dayIdx };
};

export const useOpenStatus = () => {
  const [status, setStatus] = useState(getStatus);
  useEffect(() => { const id = setInterval(() => setStatus(getStatus()), 60000); return () => clearInterval(id); }, []);
  return status;
};

export const OpenBadge = ({ className = "" }) => {
  const { open, now, today, closedToday } = useOpenStatus();
  let label = "Şu an kapalı";
  if (open) label = `Şu an açık · ${today.close}'a kadar`;
  else if (closedToday) label = "Bugün kapalı";
  else if (now < toMin(today.open)) label = `Kapalı · ${today.open}'da açılıyor`;
  return (
    <span data-testid="open-status-badge" data-open={open} className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold ${open ? "bg-emerald-400/15 text-emerald-300 border border-emerald-400/30" : "bg-white/10 text-pink-100/80 border border-white/15"} ${className}`}>
      <span className="relative flex h-2 w-2">
        {open && <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" />}
        <span className={`relative inline-flex h-2 w-2 rounded-full ${open ? "bg-emerald-400" : "bg-pink-300/60"}`} />
      </span>
      {label}
    </span>
  );
};

export const WeeklyHours = () => {
  const { dayIdx } = useOpenStatus();
  return (
    <ul className="mt-4 space-y-1" data-testid="weekly-hours">
      {OPENING_HOURS.week.map((d) => {
        const isToday = d.day === dayIdx;
        const closed = d.closed || !d.open;
        return (
          <li key={d.day} data-testid={`weekly-hours-${d.day}`} data-today={isToday} className={`flex items-center justify-between gap-4 rounded-xl px-3 py-1.5 text-sm transition-colors ${isToday ? "bg-white/15 border border-white/20 font-semibold text-white" : "text-pink-100/70"}`}>
            <span className="flex items-center gap-2">
              {isToday && <span className="h-1.5 w-1.5 rounded-full bg-grad-pink inline-block" />}
              {d.label}{isToday && <span className="text-[10px] uppercase tracking-wider text-pink-200/80">· Bugün</span>}
            </span>
            <span className="tabular-nums">{closed ? "Kapalı" : `${d.open} – ${d.close}`}</span>
          </li>
        );
      })}
    </ul>
  );
};
